import request from "./request";

// 注册
export function register(data){
    return request({
      url: 'admin/Login/register',
      method: 'post',
      data:data,
    })
}

// 验证码登录
export function captchaLogin(data){
  return request({
    url: 'admin/Login/captchaLogin',
    method: 'post',
    data:data
  })
}

// 发送验证码
export function sendVerificationCode(data){
  return request({
    url: 'common/Sms/sendVerificationCode',
    method: 'post',
    data:data
  })
}

// 管理员信息
export function getManagerDetail(token){
  return request({
    url: 'admin/Manager/getManagerDetail',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 库列表
export function getLibraryList(data,token){
  return request({
    url: 'admin/Library/getLibraryList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加词库
export function saveLibrary(data,token){
  return request({
    url: 'admin/Library/saveLibrary',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取库详情
export function getLibraryDetail(data,token){
  return request({
    url: 'admin/Library/getLibraryDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// // 添加编辑实词/虚词
// export function saveWord(data,token){
//   return request({
//     url: 'admin/Library/saveWord',
//     method: 'post',
//     data:data,
//     headers:{
//       'userToken':token
//     }
//   })
// }

// 编辑古诗文
// export function savePoem(data,token){
//   return request({
//     url: 'admin/Library/savePoem',
//     method: 'post',
//     data:data,
//     headers:{
//       'userToken':token
//     }
//   })
// }

// 更改发布状态
export function updateLibraryStatus(data,token){
  return request({
    url: 'admin/Library/updateLibraryStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除库
export function delLibrary(data,token){
  return request({
    url: 'admin/Library/delLibrary',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 复习规律
export function saveReview(data,token){
  return request({
    url: 'admin/Library/saveReview',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// AI出题
export function aiSetQuestions(data,token){
  return request({
    url: 'admin/Library/aiSetQuestions',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取七牛云获取上传token
export function getUploadToken(data,token){
  return request({
    url: 'common/Upload/getUploadToken',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取Vip列表
export function getVipList(data,token){
  return request({
    url: 'admin/vip/getVipList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取Vip详情
export function getVipDetail(data,token){
  return request({
    url: 'admin/vip/getVipDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑Vip
export function saveVip(data,token){
  return request({
    url: 'admin/vip/saveVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除vip
export function delVip(data,token){
  return request({
    url: 'admin/vip/delVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 获取苹果会员列表--连续订阅
export function getVipIphoneList(token){
  return request({
    url: 'admin/vip/getVipIphoneList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 更改Vip发布状态
export function updateVipStatus(data,token){
  return request({
    url: 'admin/vip/updateVipStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取资源包列表
export function getResourcePackList(data,token){
  return request({
    url: 'admin/vip/getResourcePackList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取库列表
export function getAllLibraryList(token){
  return request({
    url: 'admin/vip/getAllLibraryList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑资源包
export function saveResourcePack(data,token){
  return request({
    url: 'admin/vip/saveResourcePack',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取资源包详情
export function getResourcePackDetail(data,token){
  return request({
    url: 'admin/vip/getResourcePackDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除资源包
export function delResourcePack(data,token){
  return request({
    url: 'admin/vip/delResourcePack',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改资源包发布状态
export function updateResourcePackStatus(data,token){
  return request({
    url: 'admin/vip/updateResourcePackStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取积分列表
export function getPointsList(data,token){
  return request({
    url: 'admin/Badge/getPointsList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取积分详情
export function getPointsDetail(data,token){
  return request({
    url: 'admin/Badge/getPointsDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑积分
export function savePoints(data,token){
  return request({
    url: 'admin/Badge/savePoints',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取徽章列表
export function getBadgeList(data,token){
  return request({
    url: 'admin/Badge/getBadgeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取徽章详情
export function getBadgeDetail(data,token){
  return request({
    url: 'admin/Badge/getBadgeDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑徽章
export function saveBadge(data,token){
  return request({
    url: 'admin/Badge/saveBadge',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除徽章
export function delBadge(data,token){
  return request({
    url: 'admin/Badge/delBadge',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取单词列表
export function getEnglishList(data,token){
  return request({
    url: 'admin/English/getEnglishList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑单词
export function saveEnglish(data,token){
  return request({
    url: 'admin/English/saveEnglish',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取单词详情
export function getEnglishDetail(data,token){
  return request({
    url: 'admin/English/getEnglishDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除单词
export function delEnglish(data,token){
  return request({
    url: 'admin/English/delEnglish',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取诗列表
export function getPoemList(data,token){
  return request({
    url: 'admin/Poem/getPoemList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑诗
export function savePoem(data,token){
  return request({
    url: 'admin/Poem/savePoem',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑诗
export function getPoemDetail(data,token){
  return request({
    url: 'admin/Poem/getPoemDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除诗
export function delPoem(data,token){
  return request({
    url: 'admin/Poem/delPoem',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取词列表
export function getWordList(data,token){
  return request({
    url: 'admin/Word/getWordList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取词详情
export function getWordDetail(data,token){
  return request({
    url: 'admin/Word/getWordDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑词
export function saveWord(data,token){
  return request({
    url: 'admin/Word/saveWord',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除词
export function delWord(data,token){
  return request({
    url: 'admin/Word/delWord',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取苹果资源包列表
export function getResourceIphoneList(token){
  return request({
    url: 'admin/vip/getResourceIphoneList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 年级列表
export function getGradeList(data,token){
  return request({
    url: 'admin/Grade/getGradeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑年级
export function saveGrade(data,token){
  return request({
    url: 'admin/Grade/saveGrade',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 年级列表--根据类型
export function getGradeAllList(data,token){
  return request({
    url: 'admin/Grade/getGradeAllList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取包列表
export function getAllPackageList(token){
  return request({
    url: 'admin/vip/getAllPackageList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 包列表
export function getPackageList(data,token){
  return request({
    url: 'admin/Package/getPackageList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑包
export function savePackage(data,token){
  return request({
    url: 'admin/Package/savePackage',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改包发布状态
export function updatePackageStatus(data,token){
  return request({
    url: 'admin/Package/updatePackageStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取包详情
export function getPackageDetail(data,token){
  return request({
    url: 'admin/Package/getPackageDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 包--复习规律
export function PackageSaveReview(data,token){
  return request({
    url: 'admin/Package/saveReview',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取包下词列表
export function getPackageSubList(data,token){
  return request({
    url: 'admin/Package/getPackageSubList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取包下词未加入列表
export function getPackageSubNotJoinedList(data,token){
  return request({
    url: 'admin/Package/getPackageSubNotJoinedList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取库列表--根据类型
export function getLibraryAllList(data,token){
  return request({
    url: 'admin/Library/getLibraryAllList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加词
export function addWordSub(data,token){
  return request({
    url: 'admin/Package/addSub',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除包下词
export function delSub(data,token){
  return request({
    url: 'admin/Package/delSub',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除包
export function delPackage(data,token){
  return request({
    url: 'admin/Package/delPackage',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 意见反馈
export function getFeedbackList(data,token){
  return request({
    url: 'admin/Feedback/getFeedbackList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取ai识别内容
export function aiSetParams(data,token){
  return request({
    url: 'admin/Library/aiSetParams',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加ai参数
export function addLibraryAiParams(data,token){
  return request({
    url: 'admin/Library/addLibraryAiParams',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api.js